module.exports = __webpack_public_path__ + "media/media/shop/arrow-2e84d22628782dc94d8adf88630b546c.svg";